import { useEffect, useState } from "react";
import { CourseType } from "../services/courseService";
import courseApiClient from "../restApiClients/vsz/courseApiClient";

export default (courseType: CourseType, options: { organizationName?: string; } = {}) => {
  const [courses, setCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isLoading) return;

    (async () => {
      setIsLoading(true);
      const courses = await courseApiClient.list(courseType, options);
      setCourses(courses);
      setIsLoading(false);
    })();
  }, [isLoading, courseType]);

  return [
    isLoading,
    courses,
    () => setIsLoading(true)
  ] as [
      boolean,
      any[],
      () => void
    ];
};